
import React from 'react'
import { FormControl, FormLabel, RadioGroup, FormControlLabel, FormHelperText, Typography, Radio } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles({
  radio: {
    '&:hover': { backgroundColor: 'transparent' },
    '&.Mui-checked:hover': { backgroundColor: 'transparent' }
  }
})

/**
 * Material-UI Radio group field for buyflows
 */
const MuiRadioGroup = ({
  input,
  data = [],
  meta: { touched, error },
  label,
  hintText,
  className,
  horizontal = false,
  ...custom
}) => {
  const classes = useStyles()
  const hasError = touched && error
  return (
    <FormControl component="fieldset" className={className || 'radio-group'} error={hasError}>
      <FormLabel component="div" focused={false}>
        <Typography style={{ fontWeight: 500 }}>
          {label}
        </Typography>
      </FormLabel>
      <RadioGroup {...input} {...custom} row={horizontal}>
        {data.map((option, index) => (
          <FormControlLabel
            id={index}
            key={index}
            value={option.value}
            label={option.name}
            control={<Radio id={option.value} disableRipple className={classes.radio} />}
          />
        ))}
      </RadioGroup>
      <FormHelperText>{hasError ? error : hintText}</FormHelperText>
    </FormControl>
  )
}

export default MuiRadioGroup
